<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">
    <gTop />
    <gHead />
    <gNav />
    <div class="gContent" v-if="proData" :style="{minHeight: (bodyHeight - 256) + 'px'}">
      <!-- 产品信息 -->
      <div class="m-info">
        <div class="m-info-title">
          <h3 title="">{{proData.name}}</h3>

          <!-- 产品标签 -->
          <div v-if="tag.length"><span v-for="(item,index) in tag">{{item}}</span></div>
          <p>
            <Button type="info" ghost style="width:90px;height:35px;font-size:14px;" :disabled="hasCollect" @click="addCollect">关注</Button>
            <Button type="error" ghost style="width:120px;height:35px;font-size:14px;margin-left:20px;" @click="supply()">寻求商务合作</Button>
          </p>
        </div>
        <h3 title="">产品英文名：{{proData.nameEn}}</h3>
        <!-- <div class="m-info-brand">
          <div class="brand">
            <i class="icon iconfont icon-tubiao-"></i>
            <span>{{proData.applyCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-share"></i>
            <span>{{proData.shareCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-liuyan4"></i>
            <span>{{proData.commentCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-chakan"></i>
            <span>{{proData.viewCount}}</span>
          </div>
        </div> -->
        <!-- 产品类别 -->
        <div class="m-info-line" v-if="category">
          <i class="icon iconfont icon-biaoqian1" style="color: #329baa;"></i>
          <span style="padding-left: 0px;">{{category}}</span>
        </div>
        <!-- 各项认证 -->
        <div class="m-info-certificate">
          <template v-if="proData.authentication && proData.authentication.length > 0">
            <span
              class="c"
              v-for="(auth,authIdx) in proData.authentication"
              :key="'auth' + authIdx"
            >{{auth.Name}}</span>
          </template>
          <template v-if="proData.certificateQualities && proData.certificateQualities.length > 0">
            <span
              class="q"
              v-for="(authQualities,authQualitiesIdx) in proData.certificateQualities"
              :key="'authQualities' + authQualitiesIdx"
            >{{authQualities.Name}}</span>
          </template>
        </div>
        <!-- 招商区域 -->
        <div class="m-info-region" v-if="proData.zhaoShangRegion && proData.zhaoShangRegion.length > 0">
          <span style="display:inline-block;width:85px;line-height:25px;">服务地区</span>
          <div v-if="(proData.zhaoShangRegion[0] instanceof Array)">
            <span v-for="(zs,zx) in proData.zhaoShangRegion" v-if="zs.length" :key="zx">
              <template v-if="zs.length === 1">
                {{zs[0]}}
              </template>
              <template v-if="zs.length === 2">
                {{zs[0] + "/" + zs[1]}}
              </template>
              <template v-if="zs.length === 3">
                {{zs[0] + "/" + zs[1] + "/" + zs[2]}}
              </template>
            </span>
          </div>
          <div v-else>
            <span>{{proData.zhaoShangRegion[0] + "/" + proData.zhaoShangRegion[1] + "/" + proData.zhaoShangRegion[2]}}</span>
          </div>
        </div>
      </div>
      <!-- 产品内容 -->

      <div class="main">
        <div class="section">
          <div style="padding:20px 20px 0;" v-if="proData && proData.intro">
            产品简介：<p v-html="proData.intro"></p>
          </div>
          <div style="padding:20px 20px 0;" v-if="proData && proData.introductionEn">
            产品英文简介：<p v-html="proData.introductionEn"></p>
          </div>
          <div class="section-top">
            <div class="m-swiper" v-if="imgArr" style="margin-bottom:20px;">
              <!-- 轮播的banner和视频 -->
              <gSwiperCommon3 :list="imgArr"></gSwiperCommon3>
            </div>
            <!-- 产品介绍 -->
            <div class="m-content">
              <div v-for="(item,index) in proData.introduction" :key="index">
                <!-- 文字 -->
                <p class="int-text" 
                v-if="item.text" style="padding:10px 0;" 
                :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
                v-html="item.text.content ? $service.replaceSpeace(item.text.content) : '暂无介绍'"
                >
                </p>
                <!-- 图片 -->
                <div class="int-img" style="font-size:0;" v-if="item.picture && item.picture.type == 1" :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}">
                  <div v-for="(itm,idx) in item.picture.list" :key="idx" :style="{'margin-bottom':item.picture.spacing+'px'}">
                    <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)">
                  </div>
                </div>
                <!-- 轮播图片 -->
                <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
                  <gSwiperCommon2 v-if="comInfo" :comInfo="comInfo" :list="item.picture.list"></gSwiperCommon2>
                </div>
                <!-- 视频 -->
                <div class="int-video" v-if="item.video">
                  <video style="width:100%;height:100%;object-fit:fill;" :src="item.video.link" :poster="item.video.cover?item.video.cover:''" controls="controls">
                    您的浏览器不支持video标签
                  </video>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="section-bot">
            <leavingmessage @showLogin="show=true;" :typeId="proId" :type="'pro'" v-if="proId"></leavingmessage>
          </div> -->
        </div>

        <div class="sidebar" v-if="comInfo"> 
          <sidebarqrcode :url="url" :companyMsg="comInfo" :showCom="true"></sidebarqrcode>
        </div>
      </div>
    </div>
    <supplyModal v-if="proData" :show="supplyOpen" @close="supplyOpen=false" :infoData="proData" :infoType="'展品'" />
    <gInfo />
    <gBottom />
    <gLogin :show="show" @close="show=false;" />
  </div>
</template>

<script>
import gLogin from "@components/gLogin/gLogin.vue";
import gTop from "@components/gTop/gTop.vue";
import gHead from "@components/gHead/gHead.vue";
import gNav from "@components/gNav/gNav.vue";
import gBottom from "@components/gBottom/gBottom.vue";
import gSwiperCommon3 from "@components/gSwiperCommon3/gSwiperCommon3.vue"; //轮播图
import gSwiperCommon2 from "@components/gSwiperCommon2/gSwiperCommon2.vue"; //轮播图
import leavingmessage from "@components/leaving-message"; //留言
import sidebarqrcode from "@components/sidebar-QRcode"; //边栏 扫描二维码
import supplyModal from "@components/modal/supply-modal"; //供需modal
import gInfo from "@components/gInfo/gInfo.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "pro-details",
  data() {
    return {
      bodyHeight: "800px",
      proId: "",
      proData: null,
      compId:"",
      tag: [], // 产品标签
      category: "",
      zhaoShangRegion: "", // 服务地区
      comInfo: null,
      imgArr: null,
      supplyOpen: false,
      url: "",
      hasCollect: false,
      show: false,
    };
  },
  watch: {
    '$route' (to, from) {
      if(to){
        this.$nextTick(
          this.imgArr = null
        );
        this.init();
      }
    },
    user(val, oldVal) {
      this.isCollect();
    },
    proCollectId(val, oldVal) {
      this.isCollect();
    }
  },
  components: {
    gTop,
    gHead,
    gNav,
    gBottom,
    gSwiperCommon2,
    gSwiperCommon3,
    leavingmessage,
    sidebarqrcode,
    supplyModal,
    gInfo,
    gLogin
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibitionId: "getExhibitionId",
      proCollectId: "getProCollectId"
    }),
    SystemConfig() {
      return this.$store.state.SystemConfig;
    },
    showPop() {
      return this.$store.state.showPop;
    },
  },
  methods: {
    ...mapMutations({
      setProCollectId: "setProCollectId"
    }),
    ...mapActions({
      getUser: "hall/getUser",
      getWeAppCode: "exhibitionModule/getWeAppCode",
      isProCollect: "hall/isProCollect"
    }),
    async init() {
      this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
      this.proId = this.$router.history.current.params.id;
      this.compId = this.$router.history.current.query.compId;
      this.productData(); // 获取产品
      this.getCom(); // 获取对应公司
      this.getCode();
      this.isCollect();
    },
    productData() {
      // 获取产品
      this.$http.get("api/product?id=" + this.proId, this.$store.state.header).then(res => {
        if (res.status === 200 && res.data) {
          if (res.data.banner) {
            res.data.banner = JSON.parse(res.data.banner);
          }
          if (res.data.video) {
            res.data.video = JSON.parse(res.data.video);
          }
          if (res.data.tag) {
            console.log(res.data.tag,'哈哈哈');
            res.data.tag = JSON.parse(res.data.tag);
             res.data.tag.forEach(e=>{
                if (e.List && e.List.length > 0) {
              let tag = "";
              e.List.map(c => {
                tag += "/" + c.Value;
              })
              this.tag.push(e.Value + tag);
            } else {
             this.tag.push(e.Value);
            }
           })
           console.log(this.tag,'产品标签');
          }
          if (res.data.authentication) {
            res.data.authentication = JSON.parse(res.data.authentication);
          }
          if (res.data.certificateQualities) {
            res.data.certificateQualities = JSON.parse(res.data.certificateQualities);
          }
          if (res.data.category) {
            let category = JSON.parse(res.data.category);
            if (category.List && category.List.length > 0) {
              this.category = category.Value + ' > ' + category.List[0].Value;
            } else {
              this.category = category.Value;
            }
          }
          if (res.data.zhaoShangRegion) {
            res.data.zhaoShangRegion = JSON.parse(res.data.zhaoShangRegion);
          }
          if(res.data.introduction){
            res.data.introduction = JSON.parse(res.data.introduction);
          }
          let imgArr = {
            img: [],
            video: {}
          };
          imgArr.img = res.data.banner;
          imgArr.video = res.data.video;
          this.imgArr = imgArr;
          this.proData = res.data;
          if (this.proData && this.proData.intro) {
            this.proData.intro = this.proData.intro.replace(/\n/g,"<br/>");
          }
          // console.log("proData:",this.proData);
        }
      });
    },
    getCom() {
      this.$http.get("api/Join/DefaultJoin?compId=" + this.compId, this.$store.state.header).then(res => {
        if (res.status === 200 && res.data) {
          this.comInfo = res.data;
        }
      });
    },
    imgLink(e) {
      switch (e.type) {
        case "0": // 自定义
          window.location.href = e.value;
          break;
        case "1": // 公司
          this.$router.push(`/ex-details/${this.comInfo.joinId}?exhibitionId=${this.exhibitionId}&compId=${this.compId}`);
          break;
        case "3": // 产品
          this.$router.push(`/pro-details/${e.value}?compId=${this.compId}`);
          break;
        case "5": // 动态
          this.$router.push(`/chance`);
          break;
      }
    },
    async getCode() {
      let opt = {
        targetType: 1,
        targetId: this.proId,
        scene: this.proId
      }
      let data = await this.getWeAppCode(opt);
      if (data) {
        this.url = data.path;
      }
    },
    async isCollect() {
      this.setProCollectId("");
      if (!this.user) {
        return;
      }
      let isCollect = await this.isProCollect({
        userId: this.user.userId,
        productId: this.proId
      });
      this.hasCollect = isCollect;
    },
    supply() {
      if (!this.user) {
        this.show = true;
        this.$Message.warning("请登录后发布");
        return;
      }
      this.supplyOpen = true;
    },
    addCollect() {
      if (!this.user) {
        this.show = true;
        this.$Message.warning("请登录后关注");
        return;
      }
      this.$http.get(`/api/ProductFollow/follow?userId=${this.user.userId}&productId=${this.proId}`,this.$store.state.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                    this.$Message.success("关注成功！");
                    this.isCollect();
                  }else{
                    this.$Message.error("关注失败，请重新尝试");
                  }
                })
    },
  }
};
</script> 

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.home {
  background: #f5f5f5;
}
.gContent {
  background: #f5f5f5;
  width: 1200px;
  margin: 20px auto 0;
}
.top-title {
  height: 50px;
  font-size: 14px;
  line-height: 35px;
  &-link {
    color: #999;
  }
}
.main {
  width: 1200px;
  margin-top: 20px;
  margin-bottom: 80px;
  @include clearfix;

  .section {
		width: 878px;
    border-radius: 2px;
    background-color: #fff;
    float: left;
    .section-top{
      padding: 50px 65px;
      box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
    }
    .title {
      min-height: 88px;
      border-bottom: 1px solid #f5f5f5;
    }
    .title div {
      width: 690px;
      margin-left: 94px;
    }
    .title h2 {
      font-size: 24px;
      color: #222222;
      margin-top: 28px;
    }
    .title span {
      font-size: 14px;
      color: #999;
      line-height: 1.5em;
      margin-top: 36px;
    }
    .info {
      margin: 14px 0 28px;
      span {
        margin: 0;
        &:first-child {
          padding-left: 3px;
        }
        padding-left: 10px;
      }
    }
    .swiper .container {
      width: 690px;
      margin: 25px 0 0 94px;
    }
    .container2 {
      width: 690px;
      margin: 25px 0 0 94px;
    }
    .container2 p {
      font-size: 16px;
      color: #222222;
      line-height: 30px;
      margin-top: 40px;
      text-align: justify;
      word-break: break-all;
    }
    .fabulous {
      height: 130px;
      text-align: center;
      margin-top: 50px;
    }
    .fabulous div {
      display: inline-block;
      width: 220px;
      height: 77px;
      border-radius: 38px;
      border: solid 2px #e6e6e6;
      text-align: center;
      line-height: 77px;
      font-size: 20px;
      color: #222222;
      cursor: pointer;
      span {
        position: relative;
        top: -5px;
      }
    }
    .msg {
      margin-left: 94px;
    }
    .more {
      height: 80px;
      text-align: center;
    }
    .more span {
      color: #040000;
      font-size: 14px;
      cursor: pointer;
      line-height: 80px;
    }

    .icon {
      width: 1em;
      height: 1em;
      vertical-align: 0em;
      fill: currentColor;
      overflow: hidden;
      margin-right: 5px;
      font-size: 30px;
    }
  }

  .sidebar {
    width: 300px;
    float: right;
    // @include empty-txt(200px, "加载中...");
  }
}

.m-info {
  min-height: 160px;
  background-color: #fff;
  padding: 20px;
  margin-top: 28px;
  &-title {
    display: flex;
    align-items: center;
    // margin-bottom: 10px;
    position: relative;
    h3{
      font-size: 24px;
      font-weight: bold;
      color: #333;
      max-width: 560px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 20px;
    }
    span{
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: #d13119;
      display: inline-block;
      padding:0 6px;
      border-radius: 4px;
      background:rgba(209,49,25,.15);
      margin-right: 10px;
    }
    p{
      position: absolute;
      right: 0;
    }
  }
  &-brand {
    display: flex;
    align-items: center;
    // margin-bottom: 6px;
    .brand {
      align-items: center;
      display: flex;
      margin-right: 15px;
      color:#999;
      height: 32px;
      span{
        font-size: 16px;
      }
      i{
        font-size: 22px;
      }
      .icon-chakan{
        font-size: 24px;
      }
    }
  }
  &-line {
    width: calc(100% - 140px);
    margin-right: 10px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    i{
      font-size: 20px;
    }
  }
  &-region {
    width: calc(100% - 140px);
    margin-right: 10px;
    display: flex;
    div {
      span {
        display: inline-block;
        border-radius: 4px;
        background-color: #f5f5f5;
        margin-right: 10px;
        margin-bottom: 5px;
        padding: 2px 10px;
      }
    }
  }
  &-certificate {
    width: calc(100% - 140px);
    margin: 10px 10px 14px 0;
    span {
      margin-right: 10px;
      margin-bottom: 5px;
      border-radius: 4px;
      border: solid 1px #ff7a1f;
      padding: 2px 10px;
    }
    .c {
      color: #ff7a1f;
    }
    .q {
      color: #1890ff;
      border: solid 1px #1890ff;
    }
  }
}
.m-content {
	p {
		padding: 43px 0;
	}
	img {
		width: 100%;
	}
}
.section-bot{
  border-top: 20px solid #f5f5f5;
  width: 100%;
	background-color: #fff;
}
.int-video {
  width: 750px;
  height: 500px;
  // margin: 10px 0;
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>
